import { render, staticRenderFns } from "./select-people-one.vue?vue&type=template&id=d6fecdd4&scoped=true"
import script from "./select-people-one.vue?vue&type=script&lang=js"
export * from "./select-people-one.vue?vue&type=script&lang=js"
import style0 from "./select-people-one.vue?vue&type=style&index=0&id=d6fecdd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6fecdd4",
  null
  
)

export default component.exports